import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LoadingService } from '../../service/loading.service';
import { NotificationService } from '../../service/notification.service';
import { Router } from '@angular/router';
import { VendorInvoiceService } from '../../service/vendor-invoice.service';
import _ from 'lodash';
import { UtilityService } from '../../service/utility.service';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions, ColDef } from 'ag-grid-community';
import moment from 'moment';

@Component({
  selector: 'app-invoice-history',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AgGridAngular],
  templateUrl: './invoice-history.component.html',
  styleUrl: './invoice-history.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceHistoryComponent implements OnInit {
  invoices: any[] = [];
  vendorId = JSON.parse(localStorage.getItem('vendorId') || '{}');
  form: FormGroup;
  submitted: boolean;
  Activedata: boolean;
  isSearched = false;
  readonly clientId!: string;
  rowData: any[] = [];
  years = [];
  prefixLabel: string = '';
  public keepDetailRowsCount: any;
  public paginationPageSize = 20;

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'normal',
    suppressColumnVirtualisation: true,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Sr',
      valueGetter: (params: any) => {
        return params.node.rowIndex + 1;
      },
      sortable: true,
      filter: true,
      editable: false,
      width: 70,
    },
    {
      headerName: 'Invoice Number',
      field: 'invoiceNumber',
      sortable: true,
      filter: true,
      editable: true,
      cellRenderer: (params: any) => {
        if (!params?.value) {
          return '-';
        }
        return params.value;
      },
    },
    {
      headerName: 'Invoice Date',
      field: 'invoiceDate',
      sortable: true,
      filter: true,
      editable: true,
      filterParams: {
        valueFormatter: (params: any) => {
          if (params?.value) {
            return moment(params.value).format('MM/DD/YYYY');
          }
          return '';
        },
      },
      cellRenderer: (params: any) => {
        if (!params?.value) {
          return '-';
        }
        if (params?.data) {
          return moment(params?.data?.invoiceDate)?.format('MM/DD/YYYY');
        }
        return '';
      },
    },
    {
      headerName: 'Invoice Amount',
      field: 'invoiceAmount',
      sortable: true,
      filter: true,
      editable: true,
      cellRenderer: (params: any) => {
        if (!params?.value) {
          return '-';
        }
        return params.value;
      },
    },
    {
      headerName: 'Invoice Status',
      field: 'invoiceStatus',
      cellClass: (params: any) =>
        params.value === 'In Progress'
          ? 'status-in-progress'
          : 'status-Approved',
      sortable: true,
      filter: true,
    },
  ];

  defaultColDef = {
    resizable: true,
    flex: 1,
    minWidth: 100,
    floatingFilter: true,
    sortable: true,
    filter: true,
    wrapText: true,
    autoHeight: true,
  };

  constructor(
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private notifyService: NotificationService,
    private cd: ChangeDetectorRef,
    private invoiceHistoryService: VendorInvoiceService,
    private router: Router,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
  ) {
    this.form = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      fiscalYear: [null, Validators.required],
    });
  }

  ngOnInit() {}

  onGridReady(params: any) {
    const gridApi = params.api;
    gridApi.sizeColumnsToFit();
  }

  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.isSearched = true;

    if (this.form.invalid) {
      this.utilityService.getFormValidationErrors(this.form);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }
    const vendorId = JSON.parse(localStorage.getItem('vendorId') || '{}');
    let request = _.cloneDeep(this.form.value);
    this.loadingService.OnLoading.emit(true);
    this.invoiceHistoryService
      .invoiceHistory(request.fiscalYear, vendorId, this.prefixLabel)
      .subscribe(
        (data: any) => {
          this.loadingService.OnLoading.emit(false);
          this.rowData = data.map((invoice: any) => {
            return {
              invoiceNumber: invoice.invoiceNumber,
              invoiceDate: invoice.invoiceDate,
              invoiceAmount: invoice.poAmount,
              invoiceStatus: invoice.isCompleted
                ? `Approved on ${new Date(invoice.completedDate).toLocaleDateString()}`
                : 'In Progress',
            };
          });
          if (data.length == 0) {
            this.Activedata = false;
          } else {
            this.Activedata = true;
          }
          this.cd.detectChanges();
        },
        (error: any) => {
          this.loadingService.OnLoading.emit(false);
          this.notifyService.showError(error, 'Error');
          this.Activedata = false;
        },
      );
  }
}
